import Cookies from 'js-cookie';

export function logOut(){
    localStorage.removeItem('loginEventMemberUserId');
    localStorage.removeItem('loginEventMemberUserName');
    localStorage.removeItem('loginEventMemberUserEmail');
    localStorage.removeItem('loginEventMemberUserImage');
    localStorage.removeItem('loginMemberUserId');
    localStorage.removeItem('loginMemberUserName');
    localStorage.removeItem('isMember');
    localStorage.removeItem('isEventMember');
    Cookies.remove('eventMemberUserId');
}